import { FC, useEffect, useState } from "react";
import styles from "./HomePage.module.scss";
import { Button } from "../../components";
import { GirlItem, IGirlItem } from "../../components/GirlItem/GirlItem";
import { ClubCard, IClubCard } from "../../components/ClubCard/ClubCard";
import { getClubs } from "../../api/clubs";
import Loader from "../../components/Loader/Loader";
import { IResponseGetClubs } from "../../types/club";
import { ErrorPage } from "../ErrorPage/ErrorPage";
import { IResponseGetUsers } from "../../types/user";
import { getUsers } from "../../api/user";
import { transformUsersToGirlItems } from "../../helpers/transform-user-to-models";
import { Link } from "react-router-dom";
import MapWithMarkers from "../../components/MapWithMarkers/MapWithMarkers";

export const HomePageEN: FC = () => {
  const [clubs, setClubs] = useState<IClubCard[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [girls, setGirls] = useState<IGirlItem[]>([]);

  async function fetchData() {
    try {
      setIsLoading(true);
      const models: { users: IResponseGetUsers[] } = await getUsers();
      setGirls(transformUsersToGirlItems(models.users));

      const clubs: IResponseGetClubs = await getClubs();
      setClubs(
        clubs.data.map((club) => ({
          id: club.id,
          name: club.club,
          image:
            club.clubsPhotos.length > 0
              ? club.clubsPhotos[0].photoUrl
              : "https://placehold.co/400",
        })),
      );
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  if (isLoading)
    return (
      <div className="loader-container">
        <Loader size={100} borderWidth={7} />
      </div>
    );

  return (
    <section className="section">
      <div className={styles.preview}>
        <h1 className={styles.preview__title}>CASINO24.COM</h1>
        <h2 className={styles.preview__subtitle}>Join us</h2>
        <p className={styles.preview__text}>
          Welcome to Casino24.com, where we provide exclusive bonuses and
          raffles to our visitors. We are dedicated to providing a premium
          gaming experience to all of our users, and are committed to making
          sure our users have access to the latest and greatest in online casino
          gaming.
        </p>
        <div className={styles.preview__button}>
          <Link to="https://www.casino24.com" target="_blank">
            <Button>VISIT US</Button>
          </Link>
        </div>
      </div>

      <div className={styles.girls}>
        <h2 className={styles.girls__title}>Fragebögen</h2>
        <ul className={styles.girlCards}>
          {girls.slice(0, 12).map((girl) => (
            <GirlItem {...girl} />
          ))}
        </ul>
      </div>

      <div className={styles.map}>
        {/* <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d79970.0548973307!2d6.85078637873209!3d51.21789269531684!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b8cddd77250e4f%3A0x42760fc4a2a7550!2zNDA2OTkg0K3RgNC60YDQsNGCLCDQk9C10YDQvNCw0L3QuNGP!5e0!3m2!1sru!2sua!4v1734547265475!5m2!1sru!2sua"
          width="100%"
          height="420"
          style={{ border: 0 }}
          title="Google Maps Embed"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe> */}
        <MapWithMarkers />
      </div>

      <div className={styles.clubs}>
        <h2 className={styles.clubs__title}>Clubs</h2>
        <p className={styles.clubs__subtitle}>Beste Escortclubs</p>
        <ul className={styles.clubs__list}>
          {clubs.map((club) => (
            <ClubCard {...club} />
          ))}
        </ul>
      </div>
    </section>
  );
};
